'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Popover = require('material-ui/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonDropdown = function (_Component) {
  _inherits(ButtonDropdown, _Component);

  function ButtonDropdown(props) {
    _classCallCheck(this, ButtonDropdown);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ButtonDropdown).call(this, props));

    _this.handleTouchTap = function (event) {
      event.preventDefault();

      _this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    };

    _this.handleRequestClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.componentWillReceiveProps = function (newProps) {
      if (newProps.timestamp != _this.props.timestamp) {
        _this.handleRequestClose();
      }
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(ButtonDropdown, [{
    key: 'render',
    value: function render() {

      var ButtonClass = this.props.buttonclass;
      var buttonprops = Object.assign({}, this.props.buttonprops, {
        onTouchTap: this.handleTouchTap
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ButtonClass, buttonprops),
        _react2.default.createElement(
          _Popover2.default,
          {
            open: this.state.open,
            anchorEl: this.state.anchorEl,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' },
            onRequestClose: this.handleRequestClose
          },
          this.props.children
        )
      );
    }
  }]);

  return ButtonDropdown;
}(_react.Component);

exports.default = ButtonDropdown;


/** WEBPACK FOOTER **
 ** ../kettle-ui/lib/ButtonDropdown.js
 **/